export enum TEXTAREA_SIZE {
  small = "small",
  medium = "medium",
}

export enum TEXTAREA_KIND {
  primary = "primary",
  secondary = "secondary",
}
